import { home } from './home';

export const es = {
  ...home,
};
